import Chip, { ChipProps } from "@mui/material/Chip";
import { useTranslation } from "react-i18next";

import { MedicalStatus } from "../types/processTypes";

const STATUS_COLOR: Record<MedicalStatus, ChipProps["color"]> = {
  [MedicalStatus.not_done]: "default",
  [MedicalStatus.booked]: "info",
  [MedicalStatus.completed]: "primary",
  [MedicalStatus.record_not_found]: "warning",
  [MedicalStatus.expired]: "warning",
  [MedicalStatus.fit]: "success",
  [MedicalStatus.unfit]: "error",
};

interface Props {
  status?: MedicalStatus;
  size?: ChipProps["size"];
}

export const MedicalStatusChip = ({ status, size = "small" }: Props) => {
  const { t: te } = useTranslation("enums");
  const value = status ?? MedicalStatus.not_done;
  const isDefault = value === MedicalStatus.not_done;

  return (
    <Chip
      label={te(value)}
      color={STATUS_COLOR[value]}
      variant={isDefault ? "outlined" : "filled"}
      size={size}
      sx={{ fontWeight: 600, fontSize: "0.7rem" }}
    />
  );
};
